import * as React from 'react';
export const useMenuSplitGroupContextValues = (state)=>{
    'use no memo';
    return React.useMemo(()=>{
        return {
            menuSplitGroup: {
                setMultiline: state.setMultiline
            }
        };
    }, [
        state.setMultiline
    ]);
};
